/**
 * Feature flags for the admin dashboard.
 *
 * These gate UI that has been temporarily hidden but not deleted, so the code
 * paths stay intact and can be re-enabled by flipping a single flag.
 *
 * - SHOW_SLA: SLA alert bell, SLA countdown/timer badges, SLA columns, and SLA
 *   config fields across the whole dashboard.
 * - SHOW_PRIORITY: customer priority scoring — the Priority Config tab plus all
 *   priority score badges/displays in order and customer views.
 */
export const SHOW_SLA = false;
export const SHOW_PRIORITY = false;
